import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CommonUtilityService } from './utility/common-utility.service';
import { SharedService } from './shared.service';
import { CustomThemeService } from './utility/custom-theme.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MaterialModulesModule } from './material-modules/material-modules.module';
import { ChatbotComponent } from '@dbug3/chatbot-angular';


@Component({
  imports: [
    CommonModule,
    MaterialModulesModule,
    MatProgressBarModule,
    RouterOutlet,
    ChatbotComponent
],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true
})

export class AppComponent implements OnInit {
  searchFilterOpened: boolean
  sideMenuOpened: boolean
  progressBar: boolean = false;
  constructor(private commonUtilityService: CommonUtilityService,
    private sharedService: SharedService,
    private renderer: Renderer2,
    private customThemeService: CustomThemeService,
    public router: Router,
    private readonly cdr: ChangeDetectorRef
  ) { }
  ngOnInit(): void {
    this.commonUtilityService.sideMenuOpened$.subscribe((sideMenuOpened: boolean) => {
      this.toggleBodyClass('sideMenuOpened', sideMenuOpened);
    });

    this.commonUtilityService.searchFilterOpened$.subscribe((searchFilterOpened: boolean) => {
      this.toggleBodyClass('searchFilterOpened', searchFilterOpened);
    });

    this.sharedService.progressBar$.subscribe((state: boolean) => {
      this.progressBar = state;
      this.cdr.detectChanges();
    });

    const savedTheme = JSON.parse(localStorage.getItem('APP_THEME') || '{}');

    if (!this.router.url.includes('summary') && savedTheme) {
      this.customThemeService.applyTheme(savedTheme);
    }
    // Load Google Maps script once at app start so components can rely on window.google
    this.sharedService.loadGoogleMapsScript().then(() => {
      console.log('Google Maps script loaded at startup');
    }).catch(err => {
      console.warn('Google Maps script failed to load at startup', err);
    });

  }

  get isLoggedIn(): boolean {
    return !!localStorage.getItem('token');
  }

  onChatbotOpenClose(open: boolean): void {
    this.commonUtilityService.changeChatbotOpened(open);
  }

  toggleBodyClass(className: string, condition: boolean) {
    if (condition) {
      this.renderer.addClass(document.body, className);
    } else {
      this.renderer.removeClass(document.body, className);
    }
  }
  title = 'yokahu-broker-portal';
}
